import { useCallback, useEffect, useRef, useState } from 'react'

/**
 * 移动端：当日期/时间等下拉框打开时锁定页面滚动，避免滑动选择时整页跟着滑动（误触）。
 * 返回 lock / unlock，在 DatePicker 的 onOpenChange、Select 的 onDropdownVisibleChange 中调用。
 */
export function useLockBodyScrollWhenDropdownOpen() {
  const openCountRef = useRef(0)
  const [lockBody, setLockBody] = useState(false)
  const scrollYRef = useRef(0)

  const lock = useCallback(() => {
    openCountRef.current += 1
    if (openCountRef.current === 1) {
      setLockBody(true)
    }
  }, [])

  const unlock = useCallback(() => {
    openCountRef.current = Math.max(0, openCountRef.current - 1)
    if (openCountRef.current === 0) {
      setLockBody(false)
    }
  }, [])

  useEffect(() => {
    if (!lockBody) return
    scrollYRef.current = window.scrollY
    document.body.style.overflow = 'hidden'
    document.body.style.position = 'fixed'
    document.body.style.top = `-${scrollYRef.current}px`
    document.body.style.left = '0'
    document.body.style.right = '0'
    document.body.style.width = '100%'

    return () => {
      document.body.style.overflow = ''
      document.body.style.position = ''
      document.body.style.top = ''
      document.body.style.left = ''
      document.body.style.right = ''
      document.body.style.width = ''
      window.scrollTo(0, scrollYRef.current)
    }
  }, [lockBody])

  return { lock, unlock }
}
